<template>
  <main class="content">
      <div class="row">
          <h1>
              Add new city
          </h1>
      </div>
      <form class="form" novalidate v-on:submit.prevent="addCity">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

          <fieldset class="form--item">
              <label class="label" for="">
                  City:
              </label>
              <div class="input_text" id="name">
                  <input name="" required v-model="city.name" placeholder="Write a city name" type="text"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Timezone:
              </label>
              <div class="input_text" id="timezone">
                  <v-select v-model="city.timezone" required :searchable="false" placeholder="Click to select a Timezone" :options="timezones"></v-select>
              </div>
          </fieldset>
          <div class="row">
              <button class="btn btn_blue" type="submit">
                  Add city
              </button>
          </div>
      </form>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as HttpService from '../../services/http.service'

import vSelect from "vue-select"
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as CreateResource from '../../mixins/createResource.mixin';

const moment = require('moment-timezone');;

export default {
  name: 'AddCity',
  components: {vSelect, Message, Loading},
  mixins: [ValidateForm, CreateResource],
  data () {
    return {
      city: {},
      resource: 'cities',
      parentResource: 'Cities',
      timezones: moment.tz.names(),
      required_fields: [
        {'attribute': 'city.name', 'message': 'Name is missing', 'id': 'name'}, 
        {'attribute': 'city.timezone', 'message': 'Timezone is missing', 'id': 'timezone'}
      ],
    }
  },
  methods: {
    addCity(){
      this.createResource(this.city);
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AddCities.vue?1e8a9e6e